/**
 * Plain two-wave glyph (no background). Used in the nav brand row.
 * Inherits color from `currentColor`.
 */

interface Props {
  size?: number;
  className?: string;
}

export function WaveGlyph({ size = 26, className }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M3 18 Q 8 8, 13 18 T 23 18"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M9 22 Q 14 12, 19 22 T 29 22"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
